import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { Award, Tag, TrendingUp } from 'lucide-react';

export function UserStatsGrid({ user, stats, levelProgress, claimsSectionRef, navigate }) {
  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-6 mb-4 sm:mb-8">
      <Card className="hero-card" data-testid="gamification-card">
        <CardHeader className="p-3 sm:p-6 pb-0 sm:pb-0">
          <CardTitle className="flex items-center gap-1 sm:gap-2 text-xs sm:text-base">
            <Award className="h-3.5 w-3.5 sm:h-5 sm:w-5" /> <span className="truncate">Progresso</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-2 sm:pt-4">
          <div className="space-y-2 sm:space-y-4">
            <div>
              <div className="flex justify-between text-[10px] sm:text-sm mb-1 sm:mb-2">
                <span>Nv {user?.gamification_level}</span>
                <span className="font-bold">{user?.gamification_points % 100}/100</span>
              </div>
              <Progress value={levelProgress} className="h-1.5 sm:h-3" />
            </div>
            <div className="text-center pt-2 sm:pt-4 border-t border-white/20">
              <p className="text-lg sm:text-2xl font-bold">{user?.gamification_points}</p>
              <p className="text-[9px] sm:text-xs text-slate-300">Total Pontos</p>
            </div>
            <Button size="sm" onClick={() => navigate('/leaderboard')} className="w-full bg-white/20 hover:bg-white/30 text-white border border-white/30 text-[10px] sm:text-xs py-1 sm:py-2 h-auto" data-testid="leaderboard-btn">
              Ver Ranking
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card className="hero-card cursor-pointer hover:ring-2 hover:ring-white/40 transition-all" data-testid="claims-stats"
        onClick={() => claimsSectionRef.current?.scrollIntoView({ behavior: 'smooth' })}>
        <CardHeader className="p-3 sm:p-6 pb-0 sm:pb-0">
          <CardTitle className="flex items-center gap-1 sm:gap-2 text-xs sm:text-base">
            <Tag className="h-3.5 w-3.5 sm:h-5 sm:w-5" /> <span className="truncate">Cupons</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-2 sm:pt-4">
          <p className="text-2xl sm:text-3xl font-bold">{stats?.total_claims || 0}</p>
          <p className="text-[10px] sm:text-sm text-slate-300 mt-0.5 sm:mt-1">Ativados</p>
        </CardContent>
      </Card>

      <Card className="hero-card" data-testid="validations-stats">
        <CardHeader className="p-3 sm:p-6 pb-0 sm:pb-0">
          <CardTitle className="flex items-center gap-1 sm:gap-2 text-xs sm:text-base">
            <TrendingUp className="h-3.5 w-3.5 sm:h-5 sm:w-5" /> <span className="truncate">Validações</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-2 sm:pt-4">
          <p className="text-2xl sm:text-3xl font-bold">{stats?.total_validations || 0}</p>
          <p className="text-[10px] sm:text-sm text-slate-300 mt-0.5 sm:mt-1">Validadas</p>
        </CardContent>
      </Card>
    </div>
  );
}
